exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".small-edit {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 1.3rem;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-column-gap: 0.4rem;\n     -moz-column-gap: 0.4rem;\n          column-gap: 0.4rem;\n  line-height: 1.3rem;\n  top: 0.4rem;\n  position: relative;\n}\n.small-edit svg {\n  height: 1.2rem;\n  width: 1.2rem;\n  top: -0.2rem;\n  position: relative;\n}", ""]);

// exports
